module.exports = __webpack_public_path__ + "img/ICMWebinar.36e94755.png";